import React from "react";
import { useAuth0 } from "@auth0/auth0-react"; // Importa el hook de Auth0
import { Button, Result } from "antd";

export const NoOrganizations = () => {
	const { logout } = useAuth0(); // Extrae la función de logout del hook

	const handleLogout = () => {
		logout({ returnTo: window.location.origin }); // Configura la URL en Auth0
	};

	return (
		<Result
			status="403"
			title="No tienes organizaciones disponibles o no has verificado tu correo"
			subTitle="Por favor, contacta con el administrador para obtener más información"
			extra={<Button type="primary" onClick={handleLogout} >Regresar</Button>}
		/>
	);
};
